import { render, staticRenderFns } from "./regularSaleSettingsPage.vue?vue&type=template&id=2531bb30&"
import script from "./regularSaleSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./regularSaleSettingsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports